export function getTagsOptions(array, string) {
    return array
        .filter(tag => tag.includes(string))
        .map(tag => ({ label: tag, id: tag }));
}
//# sourceMappingURL=tag.js.map